import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import {CampoSelect, CampoTexto} from '../../components/processo/CamposProcesso.jsx';

/* Aba "Email": campus e endereço remetente dos e-mails do processo de seleção. */
export default function TabEmail({control, errors, campiRemetente = []}) {
    return (
        <Grid container spacing={3}>
            <CampoSelect control={control} errors={errors} nome='email.idCampus' rotulo='Campus *'
                         opcoes={campiRemetente.map(campus => ({valor: String(campus.id), descricao: campus.nome}))}/>
            <CampoTexto control={control} errors={errors} nome='email.email' rotulo='E-mail *' type='email'/>
        </Grid>
    );
}

TabEmail.propTypes = {
    control: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    /* Campi do apoio que podem ser remetentes: [{id, nome}]. */
    campiRemetente: PropTypes.array
};
